/**
 * Luhn check algorithm for verifying Credit Card numbers
 *
 * @see https://en.wikipedia.org/wiki/Luhn_algorithm
 */
export function luhnCheck(cardNumber: string): boolean {
  /**
   * Luhn check algorithm by `unkelpehr`
   * https://github.com/unkelpehr
   *
   * @see https://jsperf.app/credit-card-validator/16
   */
  /* eslint-disable */
  // @ts-ignore
  const needForSpeed = (function (arr) {
    // @ts-ignore
    return function (value) {
      let len = value.length,
        bit = 1,
        sum = 0;

      while (len--) {
        sum += !(bit ^= 1) ? parseInt(value[len], 10) : arr[value[len]];
      }

      return sum % 10 === 0 && sum > 0;
    };
  })([0, 2, 4, 6, 8, 1, 3, 5, 7, 9]);
  /* eslint-enable */

  const sanitizedCardNumber = cardNumber.replace(/\s/g, "");

  return needForSpeed(sanitizedCardNumber);
}
